var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDangerGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00008 2.99325L13.0201 11.6666H2.98008L8.00008 2.99325ZM8.00008 0.333252L0.666748 12.9999H15.3334L8.00008 0.333252ZM8.66675 9.66659H7.33341V10.9999H8.66675V9.66659ZM8.66675 5.66659H7.33341V8.33325H8.66675V5.66659Z",
    fill: "#5C6F8A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDangerGray);
export default __webpack_public_path__ + "static/media/icon_danger_gray.c5ff3d542bcf8ab73346abc01fbf353c.svg";
export { ForwardRef as ReactComponent };